import styled from "styled-components";

const FieldContainer = styled.div`
  display: flex;
  align-items: flex-end;
`;

export default FieldContainer;
